/* eslint-disable no-magic-numbers */
import { VennMapDim, VennMapName, VennSeriesOption } from './type';

export const defaultOption: VennSeriesOption = {
  type: 'map',
  dvType: 'venn',
  dvNameProperty: 'name',
  dvDimensionCount: null,
  map: null,
  dvColors: ['#FCE7CC', '#F1D5FA', '#E1D4FC', '#D7DBFC', '#D1E5FA', '#D0F1F2', '#FDF1CC'],
  data: null
};

export const titleDefaultOption = {
  overflow: 'truncate',
  ellipsis: '...'
};

export const VENN_MAP_NAME: VennMapName[] = [
  'VENN__1',
  'VENN__2',
  'VENN__3',
  'VENN__4',
  'VENN__5',
  'VENN__6',
  'VENN__7'
];

export const VENN_TITLE_NAME = [
  'A_title',
  'B_title',
  'C_title',
  'D_title',
  'E_title',
  'F_title',
  'G_title'
];

export const VENN_TITLE_ALIGN: {
  [k in VennMapName]?: {
    [key: string]: 'left' | 'right' | 'center';
  };
} = {
  VENN__2: {
    A_title: 'right',
    B_title: 'left'
  },
  VENN__3: {
    B_title: 'left',
    C_title: 'right'
  },
  VENN__4: {
    A_title: 'right',
    B_title: 'right',
    C_title: 'left',
    D_title: 'left'
  },
  VENN__5: {
    B_title: 'left',
    C_title: 'left',
    E_title: 'right'
  },
  VENN__6: {
    B_title: 'right',
    C_title: 'right',
    D_title: 'left',
    E_title: 'left'
  },
  VENN__7: {
    B_title: 'left',
    C_title: 'left',
    E_title: 'right',
    F_title: 'right',
    G_title: 'right'
  }
};

/** 韦恩图区块中心偏移，部分区块的中心并不是包围盒中点 */
export const REGION_CENTER_OFFSET = {
  VENN__6: {
    B: [-45, -5],
    C: [-30, 25]
  }
};

export const DEFAULT_TITLE_ALIGN = 'center';

/** 韦恩图最小集合数 */
export const VENN_DIM_MIN_EXTENT = 1;
/** 韦恩图最大集合数 */
export const VENN_DIM_MAX_EXTENT = 7;

/** 图表数据与地图元素的关联属性，韦恩图固定为name字段 */
export const UNIQUEKEY = 'name';

/** 图表集合的索引 */
export const LABEL_KEYS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

/** 韦恩图地图名前缀 */
export const VENN_MAP_PREFIX = 'VENN__';

export const getVennMapName = (dim: VennMapDim): VennMapName => {
  return VENN_MAP_NAME[dim - 1];
};

export const getTitleName = (index: number) => {
  return VENN_TITLE_NAME[index];
};
